module.exports = __webpack_public_path__ + "media/images/covid/icons/trayS-d401908aa6467e38192e2a74f52040d6.png";